module.exports = __webpack_public_path__ + "media/img/casa-15b60550.jpg";